(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.featured-collection');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const featuredCollectionLazy = entry.target.querySelector('.featured-collection-lazy');
        if(featuredCollectionLazy) {
          featuredCollectionLazy.style.display = 'block';
        }
        observer.unobserve(entry.target); 
      }
    });
  }, {
    threshold: 0.2
  });

  items.forEach(item => observer.observe(item));
});

  } catch(e) { console.error(e); }
})();
})();
